import React from 'react';

export const HeaderContext = React.createContext({
  steps: [{ key: 'key', title: 'title', order: 0 }],
  step: 0,
  prev: () => {
    /* no-op */
  },
});
